import React from "react";

import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "components/Form";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "components/MaterialDialog";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function ScannerDisconnectedDialog({ isOpen, onClose }: Props) {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        onClose={onClose}
        icon={faExclamationTriangle}
        iconColor="warning"
      >
        Scanner Disconnected
      </DialogTitle>
      <DialogContent>
        Please check the device and reconnect to continue scanning.
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Dismiss</Button>
      </DialogActions>
    </Dialog>
  );
}
